module.exports = __webpack_public_path__ + "img/20240603_txt2_03.2845cddb.png";